module.exports = __webpack_public_path__ + "static/SuisseIntl-RegularItalic-ebcfe992f82db833a4e94c9ea4477607.otf";